//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goConsultant from '@/common/mixins/goConsultant'
import call_consultant from '@/common/mixins/callConsultant'
import { CONSULATANT_CARD_IS_CALL } from '@/constant'
import { openChat } from '@/data/im'
export default {
    mixins: [
        goConsultant,
        call_consultant
    ],
    props: {
        excellent_consultants: Array,
        is_index: Boolean
    },
    methods: {
        onConsult (id) {
            if (CONSULATANT_CARD_IS_CALL) {
                call_consultant(e)
            } else {
                openChat(id, {
                    building_id: this.building_id,
                    from: this.page || ''
                })                    
            }
        }
    }
}
